import { render, staticRenderFns } from "./VoiceCallAlert.vue?vue&type=template&id=183e8eab&scoped=true&"
import script from "./VoiceCallAlert.vue?vue&type=script&lang=js&"
export * from "./VoiceCallAlert.vue?vue&type=script&lang=js&"
import style0 from "./VoiceCallAlert.vue?vue&type=style&index=0&id=183e8eab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183e8eab",
  null
  
)

export default component.exports